// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:09:57

export default {
  "id": "jelly-run-2048",
  "slug": "jelly-run-2048",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/95447102992c46629b7addf13099f990-200x120.jpg",
  "gameUrl": "https://html5.gamedistribution.com/95447102992c46629b7addf13099f990/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Jelly Run 2048",
      "description": "Jelly Run 2048 is a challenging casual puzzle game that combines the classic 2048 number merging with exciting parkour gameplay. Guide your jelly block by swiping left or right to connect and disconnect cubes. Merge cubes to get double the number, reaching 2048 or greater. When the jelly block collides with tiles of the same number, they merge into a larger number.",
      "instructions": "Mouse click or tap to play\n",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "2048",
        "challenge",
        "parkour",
        "running"
      ]
    },
    "zh-CN": {
      "title": "果冻跑 2048",
      "description": "果冻跑2048是一款充满挑战的休闲益智游戏，它将经典的2048数字合并与刺激的跑酷玩法相结合。通过左右滑动来引导果冻方块连接和断开方块。合并方块以获得双倍数值，达到2048或更高。当果冻方块与相同数字的方块碰撞时，它们会合并成更大的数字。",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "2048",
        "挑战",
        "跑酷",
        "奔跑"
      ]
    },
    "zh-TW": {
      "title": "果冻跑 2048",
      "description": "Jelly Run 2048 是一款挑戰性輕鬆益智遊戲，結合了經典的 2048 數字合併與刺激的跳躍遊戲玩法。通過左右滑動引導果冻塊，將塊體連接或斷開。合併塊體以獲得兩倍的數字，達到 2048 或更高。當果冻塊與相同數字的塊體碰撞時，它們會合併成更大的數字。",
      "instructions": "滑鼠點擊或觸控以遊玩",
      "genres": [
        "休闲",
        "謎題"
      ],
      "tags": [
        "2048",
        "挑戰",
        "疾走",
        "跑步"
      ]
    },
    "zh-HK": {
      "title": "果冻跑 2048",
      "description": "Jelly Run 2048 為一款挑戰性輕鬆解謎遊戲，結合經典的 2048 數字合併與刺激的疾走遊戲玩法。透過左右滑動引導果凍塊連接及斷開方塊。合併方塊獲得兩倍的數字，達到 2048 或以上。當果凍塊與相同數字的磚塊碰撞時，它們會合併成更大的數字。",
      "instructions": "滑鼠點擊或觸控遊玩",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "2048",
        "挑戰",
        "懸崖跳",
        "跑步"
      ]
    },
    "ja": {
      "title": "ジェリー・ラン・2048",
      "description": "ジェリー・ラン・2048は、クラスター2048の数の合体を楽しいパークアウトプレイと組み合わせた挑戦的なカジュアルパズルゲームです。ジェリーのブロックを左または右にスワイプして、ブロックを接続または解除し、数を合体させます。ブロックを合体させると数が2倍になり、2048またはそれ以上を目指します。ジェリーのブロックが同じ数のタイルに衝突すると、それらは大きな数に合体します。",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "2048",
        "挑戦",
        "パークアウト",
        "ランニング"
      ]
    },
    "ko": {
      "title": "젤리 런 2048",
      "description": "젤리 런 2048은 클래식 2048 숫자 병합과 흥미로운 파크라운드 게임을 결합한 도전적인 캐주얼 퍼즐 게임입니다. 젤리 블록을 왼쪽이나 오른쪽으로 스와이프하여 블록을 연결하고 분리하세요. 블록을 병합하여 숫자를 두 배로 만들고 2048 이상으로 도달하세요. 젤리 블록이 같은 숫자의 타일과 충돌하면 더 큰 숫자로 병합됩니다.",
      "instructions": "마우스 클릭이나 탭하여 게임을 시작하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "2048",
        "도전",
        "파라클로",
        "달리기"
      ]
    },
    "fr": {
      "title": "Course à la Gomme 2048",
      "description": "Jelly Run 2048 est un jeu de puzzle casual défiant qui combine le classique 2048 de fusion de nombres avec un gameplay de parkour passionnant. Guidez votre bloc de gelée en glissant à gauche ou à droite pour connecter et déconnecter les cubes. Fusionnez les cubes pour obtenir le double du nombre, atteignant 2048 ou plus. Lorsque le bloc de gelée heurte des tuiles du même nombre, elles fusionnent pour former un nombre plus grand.",
      "instructions": "Cliquez sur la souris ou appuyez pour jouer",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "2048",
        "défi",
        "parkour",
        "course d'obstacles"
      ]
    }
  }
};
